import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import LocalBusinessSchema from "./components/SEO/LocalBusinessSchema";
import Navbar from "./components/Navbar";

import React from "react";
import usePageTracking from "./usePageTracking"; // 👈 ADD THIS

import Home from "./pages/Home";
import About from "./pages/About";
import Creations from "./pages/Creations";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import BottomNav from "./components/BottomNav";
import "./styles/main.css";
import AssistantChat from "./components/AssistantChat";
import BlogDetail from "./pages/BlogDetail";
import AdminBlog from "./pages/AdminBlog";
import Blogs from "./pages/Blogs";
import AdminBlogsList from "./pages/AdminBlogsList";

import Salesforce from "./pages/Salesforce";
import Shopify from "./pages/Shopify";

// 👇 NEW: city landing pages
import AppBanner from "./pages/AppBanner";
import AppsLanding from "./pages/AppsLanding";
import RaipurLanding from "./pages/RaipurLanding";
import NagpurLanding from "./pages/NagpurLanding";
import FounderPage from "./pages/founder";
function App() {

 
  return (
    <BrowserRouter>
      <TrackingWrapper />
    </BrowserRouter>
  );
}

// 👇 Wrapper component to use hook inside Router
function TrackingWrapper() {
  usePageTracking();

  return (
    <> 
      <LocalBusinessSchema />

      <Navbar />

      {/* App announcement banner below navbar */}
      <AppBanner />

      <AssistantChat />

      <Routes>

        <Route path="/" element={<Home />} />

        <Route path="/about" element={<About />} />

        <Route path="/creations" element={<Creations />} />

        <Route path="/shopify" element={<Shopify />} />

        <Route path="/salesforce" element={<Salesforce />} />

        <Route path="/services" element={<Services />} />

        <Route path="/contact" element={<Contact />} />


        <Route
          path="/website-development-company-raipur"
          element={<RaipurLanding />}
        />

        <Route
          path="/website-development-company-nagpur"
          element={<NagpurLanding />}
        />


        <Route 
          path="/apps" 
          element={<AppsLanding />} 
        />


        <Route 
          path="/Founder" 
          element={<FounderPage />} 
        />


        <Route 
          path="/blogs" 
          element={<Blogs />} 
        />

        <Route 
          path="/blog/:slug" 
          element={<BlogDetail />} 
        />

        <Route 
          path="/admin/blog" 
          element={<AdminBlog />} 
        />

        <Route 
          path="/admin/blogs" 
          element={<AdminBlogsList />} 
        />

      </Routes>


      <BottomNav />
      

    </>
  );
}

export default App;